<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-title class="ui-evaluation-card-title">
      <div class="text-subtitle-1 font-weight-bold">Información general</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Evaluado"
              :value="getFullName(evaluacion.detalle.evaluado)"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Evaluador"
              :value="getFullName(evaluacion.detalle.evaluador)"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Municipio"
              :value="evaluacion.detalle.municipio.nombre"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Fecha inicial"
              :value="evaluacion.detalle.fechaInicial"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Fecha de conclusión"
              :value="evaluacion.detalle.fechaFin"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Fecha de aplicación"
              :value="evaluacion.detalle.fechaAplicacion"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Institución de seguridad pública a la que aplica"
              :value="evaluacion.detalle.institucionSeguridadAspirada"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              class="ui-form-field"
              label="Aspirante al puesto de"
              :value="evaluacion.detalle.puestoAspirado"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.ui-evaluation-card-title {
  color: #e0e0e0 !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}
</style>
